import { createMachine } from 'xstate';

import { createPayload, handlePayment, executePayment } from './actions';

const paymentMachine = createMachine(
  {
    id: 'mock-payment',
    initial: 'idle',
    context: {
      config: null,
      request: null,
      response: null,
    },
    states: {
      idle: {
        on: {
          INITIALISE: 'loading',
        },
      },
      loading: {
        entry: ['createPayload'],
        invoke: {
          id: 'mockRequest',
          src: executePayment,
          onDone: {
            target: 'success',
            actions: ['handlePayment'],
          },
          onError: {
            target: 'failure',
            actions: ['handlePayment'],
          },
        },
      },
      success: {
        type: 'final',
      },
      failure: {
        on: {
          RETRY: {
            target: 'loading',
          },
        },
      },
    },
  },
  {
    actions: {
      createPayload,
      executePayment,
      handlePayment,
    },
  },
);

export { paymentMachine };
